import React, {useEffect, useState} from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import axios from "axios";
import {ApiUrl} from "../../../../auth/authMethods";
import SimulationData from "../Preview/SimulationData";
import {useUser} from "../../../../auth/AuthProvider";
import AlertPopup from "../../../../component/AlertPopup";
import {useNavigate} from "react-router-dom";

export default function ConfirmacaoStep({ handleBack, value, parcelasAntecipadas, selectedFundo }) {
    const [showAlert, setShowAlert] = useState(false);
    const [isRead, setIsRead] = useState(false);
    const [previewData, setPreviewData] = useState(null);
    const navigate = useNavigate();
    const { user } = useUser();

    const handleCheckboxChange = (event) => {
        setIsRead(event.target.checked);
    };

    useEffect(() => {
        const fetchParcelas = async () => {
            try {
                const response = await axios.post(`${ApiUrl}/antecipacoes/simulateAntecipacao`, {
                    parcelas: parcelasAntecipadas
                });
                return response.data;
            } catch (error) {
                console.error("Erro ao buscar parcelas:", error);
                throw error;
            }
        };

        fetchParcelas().then(data => {
            setPreviewData(data);
        }).catch(error => {
            console.error('Erro ao processar parcelas:', error);
        });

    }, [parcelasAntecipadas]);

    const handleConfirmacao = async () => {
        console.log(previewData);

        if (previewData) {
            const { parcelas } = previewData;

            const parcelasData = parcelas.map(parcela => ({
                parcelaId: parcela.parcelaId,
                fundoId: selectedFundo,
                antecipanteId: user.id,
                valorAntecipacao: parcela.valorPresente,
            }));

            try {
                await axios.post(`${ApiUrl}/antecipacoes/register`, parcelasData);
                setShowAlert(true)
            } catch (error) {
                console.error('Erro ao registrar antecipação:', error);
            }
        }
    };

    return (
        <Grid
            container
            spacing={0}
            direction="column"
            style={{ minHeight: "100vh", paddingTop: "64px" }}
        >
            <Grid item>
                <Card sx={{ maxWidth: "90%", margin: "auto" }}>
                    <CardContent>
                        <Typography variant="h5" color="textSecondary" gutterBottom>
                            Documentação
                        </Typography>
                        <Typography variant="body" color="textSecondary">
                            Nós da Rural Crédito LTDA. temos o prazer de anunciar o lançamento do seu novo serviço de antecipação de valores...
                        </Typography>
                    </CardContent>
                    <CardContent>
                        <Typography variant="h5" color="textSecondary" gutterBottom>
                            Simulação
                        </Typography>
                        {previewData ? (
                            <SimulationData previewData={previewData} />
                        ) : (
                            <Typography variant="body1" color="textSecondary">
                                Carregando simulação...
                            </Typography>
                        )}
                    </CardContent>
                    <CardContent>
                        <Box
                            sx={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                justifyContent: "center",
                                textAlign: "center",
                            }}
                        >
                            <Typography variant="h6" color="textSecondary">
                                Deseja confirmar antecipação com o valor de R${value}?
                            </Typography>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={isRead}
                                        onChange={handleCheckboxChange}
                                        color="primary"
                                    />
                                }
                                label="Eu li e concordo com os termos"
                            />
                            <Box sx={{ display: "flex", gap: 8, mt: 2 }}>
                                <Button
                                    sx={{ width: "50%", height: 50 }}
                                    color="success"
                                    variant="contained"
                                    onClick={handleConfirmacao}
                                    disabled={!isRead}
                                >
                                    Confirmar
                                </Button>
                                <Button
                                    sx={{ width: "50%", height: 50 }}
                                    color="warning"
                                    variant="contained"
                                    onClick={handleBack}
                                >
                                    Voltar para tela de antecipação
                                </Button>
                            </Box>
                        </Box>
                    </CardContent>
                </Card>
            </Grid>
            <AlertPopup
                type="confirm"
                title="Antecipação"
                message="Sua Antecipação Foi Realizada Com Sucesso!"
                showPopup={showAlert}
                setShowPopup={setShowAlert}
                onConfirm={() => navigate('/home')}
            />
        </Grid>
    );
}
